<template>
    <el-select :value="value" ref="scroll" @change="change" :clearable="clearable">
        <el-option label="全部" value="" :key="-1" v-if="isShowAll"></el-option>
        <el-option v-for="item in listObj[mergeDataObj.data]" :label="item.title" :value="item.id" :key="item.id"></el-option>
        <el-option label="" :value="-1" :disabled="true" v-if="listObj[mergeDataObj.data] && listObj[mergeDataObj.data].length">
            <p style="height: 30px;text-align:center" v-if="searchObj[mergeSearchObj.page] < Math.ceil(listObj[mergeDataObj.count] / searchObj[mergeSearchObj.page_size])"><span style="margin-right: 6px">加载中</span><i class="el-icon-loading"></i></p>
            <template v-else>
                <p style="height: 30px;text-align:center" v-if="!loading"><span style="margin-right: 6px">已经到底啦～～</span></p>
            </template>
        </el-option>
        <el-option label="" :value="-999" :disabled="true" v-else>
            <span>暂无数据</span>
        </el-option>
    </el-select>
</template>
<script>
export default {
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        propsSearchName: {
           type: Object,
           default: () => {}
        },
        propsDataName: {
           type: Object,
           default: () => {}
        },
        requestFun: {
            type: Function,
            default: () => {}
        },
        isShowAll: {
            type: Boolean,
            default: true
        },
        defaultValue: {
            type: Number,
            default: -1
        },
        clearable: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            loading: false,
            defaultSearchProps: {
                page: 'page',
                page_size: 'limit'
            },
            defaultDataProps: {
                count: 'count',
                data: 'data'
            },
            listObj: {},
            searchObj: {}
        }
    },
    computed: {
        mergeSearchObj() {
            return {...this.defaultSearchProps, ...this.propsSearchName}
        },
        mergeDataObj() {
            return {...this.defaultDataProps, ...this.propsDataName}
        }
    },
    created() {
        this.getDataList()
        this.$nextTick(() => {
            let dom = this.$refs.scroll.$refs.scrollbar.wrap
            dom.addEventListener('scroll',this.scrollLoad , false)
        })
    },
    watch: {
        mergeDataObj: {
            deep: true,
            immediate: true,
            handler(news) {
                this.listObj = {
                    [news.count]: 0,
                    [news.data]: []
                }
            }
        },
        mergeSearchObj: {
            deep: true,
            immediate: true,
            handler(news) {
                console.log(news, 'ppp')
                this.searchObj = {
                    [news.page]: 1,
                    [news.page_size]: 10
                }
            }
        }
    },
    methods: {
        scrollLoad(e) {
            const dom = e.target
            let clientHeight = dom.clientHeight
            let scrollHeight = dom.scrollHeight
            console.log(this.searchObj[this.mergeSearchObj.page], Math.ceil(this.listObj[this.mergeDataObj.count] / this.searchObj[this.mergeSearchObj.page_size]))
            if(clientHeight + e.target.scrollTop + 10 >= scrollHeight && !this.loading && this.searchObj[this.mergeSearchObj.page] < Math.ceil(this.listObj[this.mergeDataObj.count] / this.searchObj[this.mergeSearchObj.page_size])) {
                this.loading = true
                this.searchObj[this.mergeSearchObj.page]++
                this.getDataList(true)
            }
        },
        async getDataList(flag) {
            let res = await this.requestFun(this.searchObj)
            if(this.defaultValue >= 0 && !this.value) {
                this.$emit('input', res[this.mergeDataObj.data][this.defaultValue]?.id)
            }
            this.loading = false
            this.searchLoading = false
            if(flag) {
                this.listObj = {
                    [this.mergeDataObj.data]:[...this.listObj[this.mergeDataObj.data], ...res[this.mergeDataObj.data]],
                    count: res[this.mergeDataObj.count]
                }
            } else {
                this.listObj = {
                    [this.mergeDataObj.data]:res[this.mergeDataObj.data],
                    [this.mergeDataObj.count]: res[this.mergeDataObj.count]
                }
            }
        },
        change(value) {
            this.$emit('input', value)
            this.$emit('change', value)
        }
    },
}
</script>
<style lang="less" scoped>

</style>


